// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Navigation from "../../primitives/Navigation.res.js";
import * as CatalogRoutes from "../../app/Catalog/CatalogRoutes.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogProductMutations from "../../app/Catalog/CatalogProductMutations.res.js";

function CatalogProductArchiveModal(props) {
  let scope = Auth.useScope();
  let navigate = Navigation.useNavigate();
  let archiveProduct = CatalogProductMutations.useArchive(props.id);
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: I18n.t("Once the product is archived, all its variants will be archived too.\nIts variants will only be visible from the catalog by applying the \"Archive\" filter."),
        variation: "normal"
      }),
      spaceX: "xlarge",
      spaceY: "xxlarge"
    }),
    opened: props.opened,
    title: I18n.t("Confirm the archiving of this product and its variants"),
    abortButtonText: I18n.t("Cancel"),
    commitButtonText: I18n.t("Confirm"),
    commitButtonCallback: () => Future.get(archiveProduct(), result => {
      if (result.TAG === "Ok" && scope.TAG !== "Organisation") {
        return navigate(undefined, CatalogRoutes.baseRoute);
      }
    }),
    onRequestClose: props.onRequestClose
  });
}

let make = React.memo(CatalogProductArchiveModal, (oldProps, newProps) => {
  if (oldProps.id === newProps.id) {
    return oldProps.opened === newProps.opened;
  } else {
    return false;
  }
});

let Mutations;

export {
  Mutations,
  make,
}
/* make Not a pure module */
